export const BRAND = {
  50: "#f0f7ff",
  100: "#e0effe",
  200: "#bae0fd",
  300: "#7cc8fb",
  400: "#36aaf6",
  500: "#0c8ee7",
  600: "#0070c5",
  700: "#0159a0",
  800: "#064c84",
} as const;

export const ACCENT = {
  100: "#dcfce7",
  400: "#4ade80",
  500: "#22c55e",
  600: "#16a34a",
} as const;

export const GRAY = {
  50: "#f9fafb",
  100: "#f3f4f6",
  200: "#e5e7eb",
  300: "#d1d5db",
  400: "#9ca3af",
  500: "#6b7280",
  600: "#4b5563",
  700: "#374151",
  800: "#1f2937",
  900: "#111827",
} as const;

export const WHATSAPP = {
  green: "#25D366",
  darkGreen: "#075E54",
  lightGreen: "#DCF8C6",
  chatBg: "#ECE5DD",
} as const;

export const GOOGLE = {
  blue: "#4285F4",
  red: "#EA4335",
  yellow: "#FBBC05",
  green: "#34A853",
} as const;

export const INK = {
  50: "#f7f8fb",
  100: "#eef1f7",
  200: "#dde2ec",
  300: "#b8c0d0",
  400: "#8590a8",
  500: "#5b6478",
  600: "#404a63",
  700: "#2a3350",
  800: "#1a2236",
  900: "#0f1626",
  950: "#0a0e1a",
} as const;

export const SIG = {
  yellow: "#fde047",
  red: "#ef4444",
  green: "#10b981",
  amber: "#f59e0b",
} as const;
